import { CommonModule, isPlatformServer } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { User } from '../../model/user';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { FdUnauthenticatedCardComponent } from '../shared/fd-unauthenticated-card/fd-unauthenticated-card.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { UtilitiesService } from '../../services/utilities.service';
import { initPopupData } from '../../model/popup-data';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    FdUnauthenticatedCardComponent,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  email = new FormControl('', [
    Validators.required,
    Validators.minLength(3),
    Validators.email,
  ]);
  password = new FormControl('', [
    Validators.required,
    Validators.minLength(8),
  ]);
  rememberMe = new FormControl(false);

  user: User;
  signInForm = this.formBuilder.group({
    email: this.email,
    password: this.password,
    rememberMe: this.rememberMe,
  });
  visiblePassword = false;
  signInError = false;
  signInErrorMsg = 'Incorrect Username or Password';
  isServer = false;
  isDarkMode: boolean = false;
  popup = initPopupData;

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private router: Router,
    private utilities: UtilitiesService,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.isServer = isPlatformServer(platformId);
  }

  ngOnInit() {
    this.isDarkMode = localStorage.getItem('theme') === 'theme-dark';
  }

  showPassword() {
    this.visiblePassword = !this.visiblePassword;
  }

  hideError() {
    this.signInError = false;
  }

  signIn() {
    this.hideError();
    this.utilities.fullPageLoading = true;
    this.authService
      .login(
        this.signInForm.value.email,
        this.signInForm.value.password,
        this.signInForm.value.rememberMe
      )
      .subscribe({
        next: (loggedIn: any) => {
          this.utilities.fullPageLoading = false;
          if (loggedIn) {
            localStorage.setItem('expiresAt', loggedIn.expiresAt);
            this.router.navigate(['select-client']);
          } else {
            this.signInError = true;
          }
        },
        error: (error: any) => {
          this.utilities.fullPageLoading = false;
          this.popup.content = Array.isArray(error.error)
            ? error.error[0]?.message || 'Unexpected error'
            : error.error?.message || 'Unexpected error';
          this.popup.title = 'Failed';
          this.popup.warn = true;
          this.openDialog();
          this.signInError = true;
          this.signInErrorMsg = 'Invalid username/password';
        },
      });
  }

  openDialog(): void {
    var data = {
      ...this.popup,
      content: this.popup.content
    };
    this.utilities.showSnackbarAlert(data);
  }

}
